import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Fade, Button, ClickAwayListener, Paper, Popper, List, ListItemText, ListItemIcon, ListItemButton } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Link, useLocation } from 'react-router-dom';
// import { useOktaAuth } from '@okta/okta-react';
import swal from 'sweetalert';
import { useMsal } from "@azure/msal-react";
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';

const ProfileSection = () => {
  const { instance } = useMsal();
  const accounts = instance.getAllAccounts();
  const theme = useTheme();
  const location = useLocation();
  // const { oktaAuth, authState } = useOktaAuth();
  const [selectedItem, setSelectedItem] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  useEffect(() => {
    if(location.pathname === '/settings'){
      setSelectedItem('settings');
    } else {
      setSelectedItem('');
    }
  },[location.pathname])


  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const logOut = (event) => {
    const isProjectOpen = localStorage.getItem('ProjectEditing');
    if(isProjectOpen){
      swal({
        title: 'Warning',
        text: 'Please close the current editing Project before loggingout!',
        icon: "warning",
        dangerMode: true,
    });
      return false;
    }
    const keys = Object.keys(localStorage);
    for(let key in keys){
        if(keys[key] === 'Connections' || keys[key] === 'Parameters' || keys[key] === 'Events' || keys[key] === 'ECURequestPGN' || keys[key] === 'ECUReceiveMessages' || keys[key] === 'ECUConstantTxMessages' || keys[key] === 'HomePage' || keys[key] === 'ECUIDDefinitions' || keys[key] === 'ECUTransmitMessages' || keys[key] === 'Modbus' ||  keys[key] === 'ProjectEditing'){
          localStorage.removeItem(keys[key]);
        }
    }
    //oktaAuth.signOut();
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <>
      <Button
        sx={{ minWidth: { sm: 50, xs: 35 } }}
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        aria-label="Profile"
        onClick={handleToggle}
        color="inherit"
      >
        <AccountCircleRoundedIcon sx={{ fontSize: '1.5rem' }} />
      </Button>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 10]
            }
          },
          {
            name: 'preventOverflow',
            options: {
              altAxis: true
            }
          }
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <List
                  sx={{
                    width: '100%',
                    maxWidth: 350,
                    minWidth: 250,
                    backgroundColor: theme.palette.background.paper,
                    pb: 0,
                    borderRadius: '10px'
                  }}
                >
                  {/* { authState?.accessToken?.claims?.usergroups?.includes("ConfigToolAdmin") && */}
                  {accounts[0]?.idTokenClaims?.groups.includes("bc07e057-b44f-40df-ba4f-251acff402e8") &&
                    <ListItemButton selected={selectedItem === 'settings'} component={Link} to="/settings">
                      <ListItemIcon>
                        <SettingsIcon />
                      </ListItemIcon>
                      <ListItemText primary="Settings" />
                    </ListItemButton>
                  }
                  {/* } */}

                  <ListItemButton onClick={logOut}>
                    <ListItemIcon>
                      <ExitToAppIcon />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                  </ListItemButton>
                </List>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default ProfileSection;
